import axios from "axios";

export const pkiAxios = axios.create();

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT?.replace?.("/myidm","");


const idxService = {
    bulkLoadValidate: async (payload, query) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}bulk-load/csv/validate${query ? `?${query}` : ''}`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    submitBulkLoad: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}bulk-load/csv`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    submitReportingSelf: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}bulk-load/export/csv`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
 submitTestIdRequest: async (payload) => {
    try {

      console.log(
  "URL:",
  `${API_ENDPOINT}myidm/user/submitIdxTestIdCreation`
);

       const response = await axios.post(
    `${API_ENDPOINT}myidm/user/submitIdxTestIdCreation`,
    payload
);

        return response.data;

    } catch (error) {
        console.error("Error submitting Test ID request:", error);
        throw error;
    }
},

getPreProdApplications: async () => {
    try {
        const response = await axios.get(
            `${API_ENDPOINT}myidm/user/preProdIdxApplications`
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching applications:", error);
        throw error;
    }
},

getPreProdIdxDetails: async (appName, role) => {
    try {
        console.log(
            "PreProd Details URL:",
            `${API_ENDPOINT}myidm/user/preProdIdx`
        );

        const response = await axios.get(
            `${API_ENDPOINT}myidm/user/preProdIdx`,
            {
                params: {
                    appName,
                    ...(role && { role }),
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching PreProd details:", error);
        throw error;
    }
},
submitPreProdApplicationAccess: async (payload) => {
    try {
        console.log(
            "Submit PreProd Access URL:",
            `${API_ENDPOINT}myidm/user/submitPreProdApplicationAccess`
        );

        const response = await axios.post(
            `${API_ENDPOINT}myidm/user/submitPreProdApplicationAccess`,
            payload
        );

        return response.data;
    } catch (error) {
        console.error(
            "Error submitting PreProd Access Request:",
            error
        );
        throw error;
    }
},



downloadBulkTemplate: async (type = "appaccesspreprod") => {
  try {
    const response = await axios.get(
      `${API_ENDPOINT}bulk-load/csv/template?type=${type}`,
      {
        responseType: "blob",
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error downloading template:", error);
    throw error;
  }
},

validateBulkPreProdFile: async (formData) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}bulk-load/csv/validate?type=appaccesspreprod`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error validating bulk file:", error);
    throw error;
  }
},

submitBulkPreProdApplicationAccess: async (formData) => {
  try {
    const response = await axios.post(
      `${API_ENDPOINT}myidm/user/submitBulkPreProdApplicationAccess`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error submitting bulk preprod application access:",
      error
    );
    throw error;
  }
},

};

export default idxService;